import React, { useEffect, useMemo } from "react";
import { useLocation } from "react-router-dom";
import { useOidc } from "@axa-fr/react-oidc";

interface ProtectedRouteProps {
  state?: string;
  children: React.ReactElement;
}

const ProtectedRoute = ({ children, state }: ProtectedRouteProps) => {
  const location = useLocation();
  const { isAuthenticated, login } = useOidc();
   
  useEffect(() => {
    if (!isAuthenticated) {
      login(`${location.pathname}${location.search}`);
    }
  }, [isAuthenticated, login, location.pathname, location.search]);

  if (!isAuthenticated) {
    return null; 
  }

  return children;
};

export default ProtectedRoute;
